import React, {useState} from 'react';
import Breadcrumb from '../../../common/breadcrumb';
import JobsBody from "./JobsBody";
import LoadingIndicator from "../../../common/loadingIndicator";
import JobsFilters from "./JobsFilters";
import FileManager from "../../../common/file_manager/fileManager";

const Jobs = () => {
    const [tableData, setTableData] = useState([]);
    const [selectedFilesRow, setSelectedFilesRow] = useState({});
    const [formModalFiles, setFormModalFiles] = useState({isOpen: false});
    const [filters, setFilters] = useState({
        status: '',
        isLoading: false,
        isSubmitted: false,
    });

    return (
        <>
            <Breadcrumb title="Jobs" parent="Operations"/>
            <JobsFilters {...{filters, setFilters, setTableData}} />
            <JobsBody {...{filters, setFilters, tableData, setTableData, setSelectedFilesRow, setFormModalFiles}} />
            <FileManager
                fileableId={selectedFilesRow.id}
                fileableType ="App\Models\Jobs"
                setFileableId={setSelectedFilesRow}
                modalTitle="Job Files"
                modal={formModalFiles}
                setModal={setFormModalFiles}
                allowUpload={false}
                allowShareFiles={true}
            />
            <LoadingIndicator isLoading={filters.isLoading}/>
        </>
    );
}

export default Jobs;
